import checkFF from '@webapp-next/lib/feature-flag';

export function checkEndEmploymentFF(): boolean {
  return checkFF('payx-262-enable-employment-end-date-and-reason');
}

export function checkEmploymentCollapseFF(): boolean {
  return checkFF('pre-6114-employment-collapse');
}

export function checkShiftHandlingChooserFF(): boolean {
  return checkFF('payx-2419-shift-handling-chooser');
}

export function checkJobTitlesFF(): boolean {
  return checkFF('chip-1232-job-title');
}

export function checkJobTitlesM2ReleaseFF(): boolean {
  return checkFF('chip-1232-job-title-m-2-release');
}

/**
 * The M2 job title surfaces ride both flags: the M1 flag still governs whether
 * job titles exist for the tenant at all, and the M2 release flag governs the
 * later surfaces on top of it.
 */
export function checkJobTitlesM2FF(): boolean {
  return checkJobTitlesFF() && checkJobTitlesM2ReleaseFF();
}

const COLLAPSE_AGREEMENT_THRESHOLD = 1000;

export function isAboveCollapseThreshold(agreementCount: number): boolean {
  return agreementCount > COLLAPSE_AGREEMENT_THRESHOLD;
}
